// src/msalInstance.js
// Single shared MSAL instance so both React (MsalProvider) and non-React code
// (authFetch) use the same auth state / token cache.
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Keep the active account in sync after interactive login.
// (Adding the callback is safe before initialize(); events fire after init.)
msalInstance.addEventCallback((event) => {
    if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload?.account
    ) {
        msalInstance.setActiveAccount(event.payload.account);
    }
});
